import * as React from 'react'
import styled from 'styled-components'

import { TABLET } from '../../theme/breakpoints'
import { useScreenWidth } from '../../theme/hooks/useScreenWidth'
import DesktopNav from '../../molecules/DesktopNav/DesktopNav'
import Nav from '../../molecules/Nav/Nav'
import { Job } from '../../../state/reducers/jobs/jobs'

export const MobileNav = styled(Nav)`
  position: fixed;
  height: 100%;
  width: 100%;
`

export type PageNavProps = {
  onClickPlaceVacancy: () => void
  clickPlaceVacancyIsInProgress: boolean
  className?: string
  isLoggedIn: boolean
  onLogIn: () => void
  onLogOut: () => void
  itemsInCart?: number
  lastRejectedJob?: Job
}

const PageNav: React.FunctionComponent<PageNavProps> = ({
  className,
  onClickPlaceVacancy,
  clickPlaceVacancyIsInProgress,
  isLoggedIn,
  onLogIn,
  onLogOut,
  itemsInCart,
  lastRejectedJob,
}) => {
  const width = useScreenWidth()

  if (width < TABLET) {
    return (
      <MobileNav
        className={className}
        onClickPlaceVacancy={onClickPlaceVacancy}
        clickPlaceVacancyIsInProgress={clickPlaceVacancyIsInProgress}
        isLoggedIn={isLoggedIn}
        onLogIn={onLogIn}
        onLogOut={onLogOut}
        itemsInCart={itemsInCart}
        lastRejectedJob={lastRejectedJob}
      />
    )
  }

  return (
    <DesktopNav
      className={className}
      isLoggedIn={isLoggedIn}
      onClickPlaceVacancy={onClickPlaceVacancy}
      clickPlaceVacancyIsInProgress={clickPlaceVacancyIsInProgress}
      itemsInCart={itemsInCart}
      lastRejectedJob={lastRejectedJob}
    />
  )
}

export default PageNav
